<template>
  <div class="row w-100 h-100 noselect">
    <div class="col-lg-8 col-md-6 col-sm-4">
      <img
        id="background-image"
        class="d-none d-lg-block d-sm-block"
        src="@/assets/login-background.jpg"
      />
    </div>
    <div class="col-lg-4 col-md-6 col-sm-8 z-2" style="position: relative" id="right-panel">
      <b-form @submit="onResetPassword" style="margin-top: 8rem;">
        <!--password reset-->
        <b-img class="pb-5 w-50" :src="require('@/assets/LG_MetaChef.svg')" />
        <p class="result-message" v-if="resettingPassword">
          Your new password has been set!
        </p>
        <p class="error-message" v-if="noCode">
          Invalid code. Please click the link in the email.
        </p>
        <b-input-group class="click-cursor">
          <b-input-group-prepend class="input-noborder">
            <span class="input-group-text">
              <font-awesome-icon size="2x" :icon="['fa', 'lock']" />
            </span>
          </b-input-group-prepend>
          <b-form-input
            v-model="form.password"
            type="password"
            class="login-input"
            size="lg"
            placeholder="New Password"
            required
          >
          </b-form-input>
        </b-input-group>
        <!-- Login Button -->
        <b-input-group class="pt-4 click-cursor">
          <button class="btn btn-primary btn-block shadow-none login-button">
            Reset Password
          </button>
        </b-input-group>
      </b-form>
      <div>
        <!-- powered by MetaChef -->
        <img data-v-5ff415d5="" src="data:image/png;base64,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" draggable="false" class="copyright">
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router';

// Fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { faLock } from "@fortawesome/free-solid-svg-icons";

library.add(faLock);
library.add(faUserCircle);

import { getAuth, confirmPasswordReset } from 'firebase/auth';

export default defineComponent({
  name: "ChangePassword",
  data() {
    return {
      form: {} as any,
      resettingPassword: false,
      noCode: false
    };
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
      return { route, router };
    // Now you can use 'route' and 'router' in your setup function
  },
  mounted() {
    document.title = "MetaChef | Reset Password";
  },
  methods: {
    onResetPassword(e) {
      let actionCode;
      // console.log(this.$route.query.oobCode == null);
      e.preventDefault();
      if (this.route.query.oobCode != null) {
        actionCode = this.route.query.oobCode;
      } else {
        this.noCode = true;
        return;
      }
      //var mode = this.$route.query.code;
        confirmPasswordReset(getAuth(), actionCode, this.form.password)
        .then(() => {
          this.resettingPassword = true;
        })
        .catch(() => {
          console.log("invalid code?!");
        });
    }
  }
})
</script>
<style lang="scss" scoped>
@import "./custom.scss";

#background-image {
  left: -15%;
  top: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
  object-fit: cover;
}

#right-panel {
  background-color: white;
  height: 100vh;
  right: 0;
}

form {
  padding-left: 12% !important;
  padding-right: 5% !important;
}

.input-group-text > svg {
  width: 0.5em !important;
  height: 0.5em !important;
  color: #adadad;
}

.input-group-text {
  border-radius: 10px 0px 0px 10px;
  color: $input-group-text-colour;
}

input {
  border-left-style: none !important;
  font-family: "Franklin Gothic Book";
}

.login-input {
  border-left: none;
  background-color: $input-group-text-colour;
}

.input-noborder {
  border-right: none;
}

.error-message {
  text-align: left;
  color: red;
}

.result-message {
  text-align: left;
  color: black;
}

.form-control-lg {
  border-radius: 10px 10px 10px 10px;
}

.btn {
  border-radius: 10px 10px 10px 10px;
}

.copyright {
  position: absolute;
  left: 9%;
  bottom: 4%;
  float: left;
  width: 33%;
}

.login-button {
  background-color: $login-button-colour;
  border: none !important;
  height: 48px;
}
.login-button:hover {
  background-color: $login-button-colour-hover;
}
.login-button:focus {
  background-color: #56abb0;
}
</style>
